module.exports = __webpack_public_path__ + "img/user.646d9586.svg";